export const getContent = (label: string, url: string, pluginKey: string) => {
  const linkStyles = `
    padding: 8px 16px;
    font-size: 16px;
    height: 40px;
    background-color: #14060a;
    color: #fff;
    text-decoration: none;
    border-radius: 9999px;
    cursor: pointer;
    width: fit-content;
  `;

  return `<a href="${url}" target="_blank" style="${linkStyles}" data-${pluginKey}="true">${label}</a>`;
};
